import request from '@/utils/request'


export function addOrUpdateGrouted(data) {
    return request({
        url: `api/serviceCenter/superwordSet/addOrUpdateGrouted`,
        method: 'post',
        data,
    })
}


export function selectGrouted(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superwordSet/selectGrouted?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteFile(data) {
    return request({
        url: `api/serviceCenter/superwordSet/bathDeleteFile`,
        method: 'post',
        data,
    })
}



export function selectSuperwordCarvingName(data) {
    return request({
        url: `api/serviceCenter/SuperwordCarvingSet/selectSuperwordCarvingName?access=${data}`,
        method: 'post',
    })
}

export function addOrUpdateFloor(data) {
    return request({
        url: `api/serviceCenter/superwordSet/addOrUpdateFloor`,
        method: 'post',
        data,
    })
}


export function selectFloor(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superwordSet/selectFloor?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteFloor(data) {
    return request({
        url: `api/serviceCenter/superwordSet/bathDeleteFloor`,
        method: 'post',
        data,
    })
}


export function addOrUpdateSideband(data) {
    return request({
        url: `api/serviceCenter/superwordSet/addOrUpdateSideband`,
        method: 'post',
        data,
    })
}


export function selectSideband(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/superwordSet/selectSideband?access=${data}`,
        method: 'post',
       // data,
    })
}


export function bathDeleteSideband(data) {
    return request({
        url: `api/serviceCenter/superwordSet/bathDeleteSideband`,
        method: 'post',
        data,
    })
}
